/**
* ggTypes
* @namespace gplans.utils.services
*/
(function () {
  'use strict';

  angular.
  module('gplans.utils.services').
  factory('ggTypes', ggTypes);

  /**
                               * @namespace ggTypes
                               */
  function ggTypes() {
    /**
                      * @name ggTypes
                      * @desc The factory to be returned
                      */
    var ggTypes = {
      Nutritionable: NutritionableFactory };


    return ggTypes;

    ////////////////////

    /**
     * @name NutritionableFactory
     * @description representation of INutritionable interface on backend
     * @param factoryData – data for any Nutritionable object
     */
    function NutritionableFactory(factoryData) {
      var nutritionableParams = [
      // calories and macronutrients
      'calories',
      'fats',
      'proteins',
      'carbohydrates',
      // change meal items, additional information
      'exchanges',
      'portion',
      'category',
      'subcategory',
      'unit',
      // used for groceries list
      'groceries_replacement_ratio',
      'groceries_unit'];

      var nutritionableParamsDefaults = {
        unit: '',
        category: '',
        subcategory: '',
        groceries_unit: '' };


      Nutritionable.prototype.copy = copy;
      Nutritionable.prototype.update = update;
      return new Nutritionable(factoryData);
      ////

      /**
       * @description initialize Nutritionable object
       * @param data
       * @param partial {Boolean}
       * @constructor
       */
      function Nutritionable(data, partial) {
        nutritionableParams.forEach(function (param) {
          // if no data initialize an empty object with default values
          if (typeof data === 'undefined') {
            this[param] = nutritionableParamsDefaults.hasOwnProperty(param) ? nutritionableParamsDefaults[param] : 0;
            // partial initialization: data or default or 0
          } else if (partial) {
            this[param] = data[param] ? data[param] :
            nutritionableParamsDefaults.hasOwnProperty(param) ? nutritionableParamsDefaults[param] : 0;
            // full initialization: no excuses!
          } else {
            if (!data.hasOwnProperty(param)) {
              throw TypeError("Nutritionable object should contain '" + param + "' parameter.");
            }
            this[param] = data[param];
          }
        }.bind(this));
      }

      function copy(copyFrom) {
        nutritionableParams.forEach(function (param) {
          if (!copyFrom.hasOwnProperty(param)) {
            throw TypeError("Nutritionable object should contain '" + param + "' parameter.");
          }
          this[param] = copyFrom[param];
        }.bind(this));
      }

      function update(updateFrom) {
        nutritionableParams.forEach(function (param) {
          if (updateFrom.hasOwnProperty(param)) {
            this[param] = updateFrom[param];
          }
        }.bind(this));
      }
    }

  }
})();